import styled from '@emotion/styled';
import { Box, ButtonBase, Grid, Icon, Typography, useTheme } from '@mui/material';
import * as React from 'react';
import HelpIcon from '../../../../components/common/HelpIcon';
import { HelpIconInterface } from '../../../../utilities/contentful';

interface Props {
  title: string;
  selected: boolean;
  fieldData: string;
  completed: boolean;
  contentfulHelpId: string;
  submitted: boolean;
  helpIcons: HelpIconInterface[];
}


const QuoteModalTabButton = ({ title, selected, fieldData, completed, contentfulHelpId, submitted, helpIcons }: Props): JSX.Element => {
  const theme = useTheme();

  const ModalTabButton = styled(ButtonBase)(({ theme }) => ({
    width: '100%',
    borderLeft: selected ? '10px solid #5eacee' : '0',
    backgroundColor: selected ? '#425f88' : '#2c4d7a',
    minHeight: '75px',
    height: 'auto',
    textAlign: 'left',
    display: 'flex',
    justifyContent: 'flex-start',
    alignContent: 'center',
    padding: '20px'
  }));

  return (
    <Box component={ModalTabButton} disableRipple columnGap={'4px'}>
      <Grid container>
        <Grid item xs={12} display="flex" flexDirection="row" columnGap={'4px'} alignItems="center">
          <Typography align="left" variant="subtitle1" color="white" fontWeight="500" fontSize="15px">
            {title}
          </Typography>
          <HelpIcon helpIcons={helpIcons} contentfulId={contentfulHelpId} color={'light'} />
        </Grid>
        <Grid item xs={12} mt={1}>
          <Typography align="left" variant="body2" sx={{color: selected ? 'white' : '#aaaaaa'}}>
            {fieldData}
          </Typography>
        </Grid>
      </Grid>
      { completed && <Icon style={{ backgroundColor: 'white', borderRadius: '15px', color:'green' }}>check_circle</Icon> }
      { !completed && submitted && <Icon style={{ backgroundColor: 'white', borderRadius: '15px', color: theme.palette.error.main }}>cancel</Icon>}
    </Box>
  );
};

export default QuoteModalTabButton;